module.exports = __webpack_public_path__ + "static/media/mid_image.31e580d4.jpg";